var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[(_vm.action)?_c('span',{staticClass:"btn-action-link",on:{"click":function($event){return _vm.action()}}},[_c('span',{class:_vm.getDirectionIcon()})]):_c('span',[_c('span',{class:_vm.getDirectionIcon()})])])}
var staticRenderFns = []

export { render, staticRenderFns }